<template>
    <div class="margin">
        <content-item-container :showWord="true" :isCenter="true" wordPosition="center">
            <div class="reward-box">
                <img class="registered" src="../../../assets/images/postalNewCustomer/index_text_registered.png">
                <div class="reward-text">您已开通过邮储银行数字人民币钱包，无法获得开通奖励，您可以参与每日转盘抽奖赢取更多丰富奖品！</div>
                <img class="button-sign-up" @click="toLuckDraw" src="../../../assets/images/postalNewCustomer/go_luck_draw_button.png" alt="">
            </div>
        </content-item-container>
    </div>
</template>

<script>
import contentItemContainer from './ContentItemContainer.vue'

export default {
    components: { contentItemContainer },
    data() {
        return {}
    },
    computed: {},
    created() { },
    mounted() { },
    beforeDestroy() { },
    methods: {
        //去抽奖
        toLuckDraw() {
            this.$emit('toLuckDraw')
        }
    },
}
</script>

<style lang="scss" scoped>
@import "./function";
.margin {
    margin-bottom: pxvw(20);
    .reward-box {
        padding: pxvw(76) pxvw(58) pxvw(48);
        display: flex;
        align-items: center;
        justify-content: center;
        flex-direction: column;
        .registered {
            font-size: 0;
            width: pxvw(136);
            margin-bottom: pxvw(50);
        }
        .reward-text {
            font-size: pxvw(26);
            width: pxvw(548);
            text-align: justify;
            color: #898989;
            line-height: pxvw(40);
        }
        .button-sign-up {
            width: pxvw(502);
            height: pxvw(92);
            font-size: 0;
            margin-top: pxvw(36);
        }
    }
}
</style>